
import { defineComponent } from 'vue'

// link information
interface LinkInfo {
  title: string,
  url: string
}

export default defineComponent({
  name: 'LinkEn',
  data () {
    return {
      links: [
        {
          title: 'Yusuke Kato group, Department of Basic Science, The University of Tokyo',
          url: 'http://webpark1378.sakura.ne.jp'
        },
        {
          title: 'Condensed Matter Theory Laboratory, RIKEN',
          url: 'http://www2.riken.jp/lab-www/cond-mat-theory/index-e.html'
        },
        {
          title: 'Condensed Matter Theory Group, Department of Physics, Kyoto University',
          url: 'http://cond.scphys.kyoto-u.ac.jp/e_index.html'
        }
      ] as LinkInfo[]
    }
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'link'
    }
  }
})
